import request from '../common/request';

// 获取首页应用
export const getApplyConfigList = () => request({
  url: '/api//blade-apply/applyconfig/list',
  method: 'get',
});